import React, { useState, useEffect } from "react";
import "./blog.css";
import axiosConfig from "../../Service/AxiosConfig";
import { useNavigate } from "react-router-dom";
function Blog() {
  const [blogdata, setBlogData] = useState([]);
  const navigate = useNavigate();
 

  //fetch blog data intial display 4 items
  const fetchBlogs = async () => {
    try {
      const response = await axiosConfig.get("/blogapp/blog/?&page_size=4");
      const data = response?.data?.results;
      setBlogData(data);
    } catch (error) {
      console.error("Error fetching blog data:", error);
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, []);
  return (
    <div className="blog-container">
      <h2 className="blog-title">Our Blog</h2>
      <p className="blog-subtitle">Your Health, Explained by Experts</p>
      <div className="blog-card-container">
        {blogdata.map((ele, ind) => (
          <div
            className="blog-card"
            key={ind}
            style={{ cursor: "pointer" }}
            onClick={() => {
              // Use slug if available, otherwise fallback to id
              if (ele.slug) {
                navigate(`/${ele.slug}`);
              } else {
                navigate(`/${ele.id}`);
              }
            }}
          >
            <img src={ele?.image?.image} alt="blog" />
            <p className="blog-text">{ele?.title}</p>
          </div>
        ))}
      </div>
      <a href="/blog" target="_top">
        <button className="">View More</button>
      </a>
    </div>
  );
}

export default Blog;
